import api from './api';


const setAuthTokenAdmin = token => {
    if (token && token) {
        localStorage.setItem('vip_token_admin', token);
        api.defaults.headers.common['x-auth-token'] = token;
    } else {
        delete api.defaults.headers.common['x-auth-token'];
        localStorage.removeItem('vip_token_admin');
    }
};

export default setAuthTokenAdmin;
